module.exports = __webpack_public_path__ + "static/media/PLANTA.1b259c1a.png";